// src/components/bi/WeekRangePicker.jsx - VERSION SIMPLE
import React, { useState, useEffect } from 'react';
import './weekRangePicker.css';

const getMonday = (date) => {
  const d = new Date(date);
  const day = d.getDay();
  const diff = d.getDate() - day + (day === 0 ? -6 : 1);
  return new Date(d.setDate(diff));
};

const getSunday = (monday) => {
  const sunday = new Date(monday);
  sunday.setDate(sunday.getDate() + 6);
  return sunday;
};

const formatDate = (date) => {
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
};

const WeekRangePicker = () => {
  const [displayText, setDisplayText] = useState('');

  useEffect(() => {
    // Calculer la semaine actuelle (une seule fois)
    const today = new Date();
    const monday = getMonday(today);
    const sunday = getSunday(monday);

    setDisplayText(`${formatDate(monday)} - ${formatDate(sunday)}`);
  }, []);

  return (
    <div className="week-range-simple">
      <span className="week-icon">📅</span>
      <span className="week-dates">{displayText}</span>
    </div>
  );
};

export default WeekRangePicker;